import { api } from "e.sic-platform.webclient/src/services/api/ApiService";
import { observer } from "mobx-react-lite";
import { useCallback, useState } from "react";
import { ShopHistoryStorageModel } from "e.sic-platform.webclient/src/services/shop/ShopHistoryStorage";
import DataGrid from "e.sic-platform.webclient/src/components/datatable/DataGrid";
import {
  ActionsSection,
  ButtonsSection,
} from "e.sic-platform.webclient/src/components/data-components/sections/DataSections";
import DeleteButton from "e.sic-platform.webclient/src/components/buttons/delete-button/DeleteButton";
import { Box, Grid } from "@mui/material";
import { translationService } from "e.sic-platform.webclient/src/services/translation/TranslationService";

export default observer(function ShopHistoryTable() {
  const [shopHistoryStorage] = useState(() =>
    ShopHistoryStorageModel.create({}, { api })
  );

  const deleteAppResults = useCallback(() => {
    shopHistoryStorage.deleteFiles(shopHistoryStorage.selectedItems);
  }, []);

  const title = translationService.translate("shop.confirm-delete-title", {
    count: shopHistoryStorage.selectedItems.length,
  });

  return (
    <>
      <ActionsSection>
        <ButtonsSection>
          <DeleteButton
            disabled={shopHistoryStorage.cannotDelete}
            confirmationModalTitleKey={title}
            confirmationModalSubtitleKey={"shop.confirm-delete-subtitle"}
            confirmationAction={deleteAppResults}
          />
        </ButtonsSection>
      </ActionsSection>
      <Grid container className="centered" sx={{ p: 10 }}>
        <Box width="50vw">
          <DataGrid itemTypeKey={""} dataGridStorage={shopHistoryStorage} />
        </Box>
      </Grid>
    </>
  );
});
